import React, { useRef, useMemo } from 'react'
import PropTypes from 'prop-types'

import Tooltip from '../Tooltip'
import SwapButton from '../SwapButton'

import { decode } from '@aytm/app/insights/dashboard/lib/sanitize'
import { truncateStringToLength } from '@aytm/app/insights/dashboard/lib/strings'
import { useBlinkSubscription } from '@aytm/app/insights/dashboard/components/hooks/useBlink'

import './SubjectText.css'

const CLASS = 'insights-portal-subject-text'

const SubjectText = props => {
  const index = props.index ?? -1

  const containerRef = useRef()

  const targetRef = useBlinkSubscription(props.item?.uid)

  const text = useMemo(() => decode(props.text || ''), [props.text])
  const displayText = useMemo(() => truncateStringToLength(text, 72, '...'), [text])

  const textTooltip = text && text.length > 50 ? <div className={`${CLASS}-tooltip`}>{text}</div> : null

  const onEdit = event => {
    if (props.onEditorChange) {
      event.stopPropagation()
      event.preventDefault()
      props.onEditorChange({ type: 'add', menuIndex: index })
    }
  }

  const editButton =
    props.showControl && props.edit ? (
      <div className={`${CLASS}-icon`}>
        <i className={`pi pi-chevron-down insights-portal-toggle-icon-i`} onClick={onEdit} />
      </div>
    ) : null

  const button = props.swap ? (
    <SwapButton className={`${CLASS}-swap-button`} wait={props.wait} onClick={props.onSwapChange} />
  ) : (
    editButton
  )

  return (
    <div
      ref={node => {
        targetRef.current = node
        containerRef.current = node
      }}
      className={`${CLASS}${props.swap ? ` ${CLASS}-swap` : ''}`}
    >
      <div className={`${CLASS}-text`}>
        {displayText}
        {!props.swap && (
          <div className={`${CLASS}-subtitle`}>
            <small>{props.range}</small>
          </div>
        )}
      </div>
      {button}
      <Tooltip
        className={'test'}
        position={'up-right'}
        onTarget={() => containerRef.current}
        content={textTooltip}
        showOn={'mouseenter'}
        hideOn={'click&propagate mouseleave click:body wheel:body scroll:body'}
      />
    </div>
  )
}

SubjectText.propTypes = {
  className: PropTypes.string,
  item: PropTypes.object,
  text: PropTypes.any,
  range: PropTypes.any,
  blink: PropTypes.any,
  index: PropTypes.number,
  wait: PropTypes.any,
  swap: PropTypes.any,
  edit: PropTypes.any,
  showControl: PropTypes.any,
  onSwapChange: PropTypes.func,
  onEditorChange: PropTypes.func
}

SubjectText.defaultProps = {
  blink: true,
  showControl: true
}

export default SubjectText
